import snakeCase from 'lodash.snakecase';

export default class FormEvent {
  init() {
    this.wpcf7Elm = document.querySelectorAll('.wpcf7');

    if (!this.wpcf7Elm) {
      return;
    }

    document.addEventListener('wpcf7mailsent', (e) => {
      const inputsKeyValue = {};

      e.detail.inputs.forEach((input) => {
        inputsKeyValue[`form_${snakeCase(input.name)}`] = input.value;
      });

      const newLayer = {
        event: `${snakeCase(e.target.dataset.formName)}_success`,
        ...inputsKeyValue,
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(newLayer);
    });
  }
}
